module.exports = __webpack_public_path__ + "static/media/hp-technical-illustration.1ba52c5e.svg";